import Image from 'next/image'
import container from '@/public/custom-web-development-services/Container.png'

const TechstackSection = ({heading, paragraph, cardsName}) => (
    <div className="w-full relative bg-[#0e499f] lg:py-20 lg:px-6 px-10 py-10 font-inter overflow-hidden max-w-[1750px] mx-auto">
        {/* Background image */}
        <div className="absolute inset-0 z-0 ">
            <Image
                src={container}
                alt=""
                className="w-full h-full object-cover opacity-100"
            />
        </div>

        {/* Overlay content */}
        <div className="relative z-10 flex flex-col justify-center items-center gap-y-10 text-white md:text-center w-full mx-auto">
            <h2 className="font-bold text-2xl md:text-4xl w-full lg:w-[80%]">
                {heading}
            </h2>

            <p className="font-normal lg:text-xl text-base w-full lg:w-[80%] text-white/90 ">
                {paragraph}
            </p>
        </div>

        {/* animation section */}
        {cardsName && cardsName.length > 0 && (
        <div className="w-full overflow-hidden py-10 max-w-[1750px] mx-auto bg-[#0E499F] px-10 mt-14">
            <div className="flex flex-row animate-scroll">
                {cardsName && cardsName.map(
                    (logo, index) => (
                        <div key={index} className="">
                            <Image src={logo} alt="Technology logo" className="max-w-[245px]  h-[40px] object-contain" />
                        </div>
                    )
                )}
            </div>
        </div>
        )}  
        {/* animation section */}
        {cardsName && cardsName.length > 0 && (
        <div className="w-full overflow-hidden py-10 max-w-[1750px] mx-auto bg-[#0E499F] px-10">
            <div className="flex flex-row animate-scroll-reverse">
                {cardsName && cardsName.map(
                    (logo, index) => (
                        <div key={index} className="">
                            <Image src={logo} alt="Technology logo" className="max-w-[245px]  h-[40px] object-contain" />
                        </div>
                    )
                )}
            </div>
        </div>
        )}
    </div>
)

export default TechstackSection
